import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputForm, InputIcon, InputInterface } from 'src/app/classes/input';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { ISignUp } from '../user.interface';
import { AuthService } from '../auth.service';
import countries_code from 'src/app/shared/auth/signup/country-code .json';
import { CountriesCode } from 'src/app/classes/interfaces/countries.code';

const formDataInit: ISignUp = {
  password: '',
  userName: '',
  email: '',
  firstName: '',
  id: 0,
  lastName: '',
  phoneNumber: '',
  wayKnowType: 0,
  parentReferralCode: '',
  signUpURL: '',
};

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotateX(0) rotateZ(0)' })),
      state('rotated', style({ transform: 'rotateX(90deg) rotateZ(180deg)' })),
      transition('rotated => default', animate('200ms ease-out')),
      transition('default => rotated', animate('200ms ease-in')),
    ]),
  ],
})
export class SignupComponent implements OnDestroy {
  @Output('changingView') changeView: EventEmitter<boolean> =
    new EventEmitter<boolean>(false);

  @Input('refralCode') refralCode: any;

  loading = false;
  iconSrc = 'assets/icon/eye-off.svg';

  activeError1: boolean;
  activeError2: boolean;

  pathAfterCom: string;

  countries: CountriesCode[];
  showCountriesList: boolean;
  countrieIcon = 'IR';
  countriePhone = 98;
  search: string = '';
  mobileNumber: string;

  // =========================
  // Registration OTP
  // =========================
  otpStep = false;
  registrationOtpCode = '';
  otpSending = false;
  otpVerifying = false;
  otpCooldown = 0;

  private otpTimer: any;
  private otpPhoneNumber = '';
  private pendingSignupData: ISignUp | null = null;

  // =========================
  // Country
  // =========================
  countriesDropDown() {
    this.showCountriesList = !this.showCountriesList;
  }

  fillSearchValue(value: string) {
    this.search = value;
  }

  fillMobileValue(value: string) {
    this.mobileNumber = value;
  }

  get country() {
    return this.countries;
  }

  countriesSelected(code: string, phone: number) {
    this.countrieIcon = '';
    this.countriePhone = 0;

    this.countrieIcon = code;
    this.countriePhone = phone;

    this.showCountriesList = !this.showCountriesList;
  }

  // =========================
  // Way Know Type
  // =========================
  saveWayKnowType: number;
  dropDown: boolean;
  wayKnowTypeName: string = 'نحوه آشنایی با ما';
  wayKnowTypeIcon: string;
  showParentForm: boolean;
  parentReferralCode: string;

  wayKnowType: Array<any> = [
    {
      id: 0,
      label: 'گوگل',
      active: false,
      icon: 'assets/icon/chrome-icon.svg',
    },
    {
      id: 1,
      label: 'اینستاگرام',
      active: false,
      icon: 'assets/icon/ins-icon.svg',
    },
    {
      id: 2,
      label: 'تلگرام',
      active: false,
      icon: 'assets/icon/telegram-icon.svg',
    },
    {
      id: 3,
      label: 'دوستان',
      active: false,
      icon: 'assets/icon/people-icon.svg',
    },
  ];

  fillParentValue(value: string) {
    this.parentReferralCode = value;
    this.wayKnowTypeIcon = 'assets/icon/people-icon.svg';
    this.wayKnowTypeName = '';
    this.wayKnowTypeName = 'دوستان';
    this.saveWayKnowType = 3;
  }

  toggleDropDown() {
    this.dropDown = !this.dropDown;
  }

  toggle(index: number, lable: string, icon: string) {
    this.wayKnowTypeName = '';
    this.wayKnowTypeName = lable;
    this.wayKnowTypeIcon = icon;

    this.wayKnowType
      .filter((it, i) => i !== index && it.active)
      .forEach((it) => (it.active = !it.active));

    this.dropDown = !this.dropDown;
    this.wayKnowType[index].active = true;
    this.saveWayKnowType = index;

    if (this.saveWayKnowType == 3) {
      this.showParentForm = true;
    } else {
      this.showParentForm = false;
    }
  }

  ngOnInit() {}

  // =========================
  // Form
  // =========================
  formsControlInit: InputInterface[] = [
    {
      id: 1,
      label: 'نام',
      name: 'firstName',
      typeofVlaue: 'string',
      placeholder: 'نام',
      required: true,
      disable: false,
    },
    {
      id: 2,
      label: 'نام خانوادگی',
      name: 'lastName',
      typeofVlaue: 'string',
      required: false,
      placeholder: 'نام خانوادگی',
      disable: false,
    },
    {
      id: 5,
      label: 'ایمیل',
      name: 'email',
      type: 'email',
      typeofVlaue: 'string',
      required: true,
      placeholder: 'ایمیل',
      disable: false,
    },
    {
      id: 6,
      label: 'رمز عبور',
      name: 'password',
      type: 'password',
      typeofVlaue: 'string',
      required: true,
      minLength: 6,
      placeholder: 'رمز عبور',
      disable: false,
      icon: [
        {
          alt: 'eye-of',
          id: 1,
          placement: 'left-icon',
          src: 'assets/icon/eye-on.svg',
        },
      ],
    },
  ];

  state: 'default' | 'rotated' = 'default';
  formMaker = new InputForm(this.formsControlInit);
  showPass: boolean = false;
  form: FormGroup;
  formControls: InputInterface[];

  // =========================
  // Constructor
  // =========================
  constructor(private authService: AuthService) {
    this.countries = countries_code.countries;
    this.form = new FormGroup({});

    this.formMaker.inputs.forEach((item) => {
      this.form.setControl(item.name, this.formMaker.createControl(item));
    });

    this.formControls = this.formMaker.inputs;
  }

  get _formcontrol() {
    return this.form.controls;
  }

  // =========================
  // Build phone number
  // =========================
  private getRegistrationPhoneNumber(): string {
    return '+' + this.countriePhone + this.mobileNumber;
  }

  // =========================
  // Signup
  // =========================
  async signup() {
    // اگر OTP قبلاً ارسال شده، دوباره ثبت‌نام را شروع نکن
    if (this.otpStep) {
      return;
    }

    this.getRoute();

    this.loading = true;

    let formData = {
      ...formDataInit,
    } as ISignUp;

    formData.wayKnowType = this.saveWayKnowType;
    formData.password = this._formcontrol['password'].value;
    formData.email = this._formcontrol['email'].value;
    formData.firstName = this._formcontrol['firstName'].value;
    formData.lastName = this._formcontrol['lastName'].value;
    formData.parentReferralCode = this.parentReferralCode;

    formData.phoneNumber = this.getRegistrationPhoneNumber();
    formData.userName = formData.email;
    formData.signUpURL = this.pathAfterCom;

    if (formData.parentReferralCode == '') {
      formData.parentReferralCode = null;
    }

    if (await this.checkFormValidation(formData)) {
      this.pendingSignupData = formData;
      this.otpPhoneNumber = formData.phoneNumber;

      await this.sendRegistrationOTP();
    } else {
      this.loading = false;
    }
  }

  // =========================
  // Send Registration OTP
  // =========================
  async sendRegistrationOTP() {
    if (!this.otpPhoneNumber) {
      this.loading = false;
      return;
    }

    if (this.otpCooldown > 0) {
      this.loading = false;
      return;
    }

    this.otpSending = true;

    const result = await this.authService.sendRegistrationOTP(
      this.otpPhoneNumber
    );

    this.otpSending = false;
    this.loading = false;

    if (!result.success) {
      return;
    }

    this.otpStep = true;

    const remainingSeconds =
      typeof result.data === 'number' && result.data > 1
        ? result.data
        : 60;

    this.startOtpCooldown(remainingSeconds);
  }

  // =========================
  // Verify Registration OTP
  // =========================
  async verifyRegistrationOTP() {
    if (this.otpVerifying) {
      return;
    }

    const otp = Number(this.registrationOtpCode);

    if (
      !this.otpPhoneNumber ||
      !this.registrationOtpCode ||
      this.registrationOtpCode.length !== 4 ||
      !Number.isInteger(otp)
    ) {
      return;
    }

    this.otpVerifying = true;

    const result = await this.authService.verifyRegistrationOTP(
      this.otpPhoneNumber,
      otp
    );

    this.otpVerifying = false;

    if (!result.success) {
      return;
    }

    if (!this.pendingSignupData) {
      return;
    }

    this.loading = true;

    const signupSuccess = await this.authService.signup(
      this.pendingSignupData
    );

    this.loading = false;

    if (signupSuccess) {
      this.stopOtpCooldown();
      this.otpStep = false;
      this.registrationOtpCode = '';
      this.pendingSignupData = null;
      this.otpPhoneNumber = '';

      this.changeView.emit(true);
    }
  }

  backToRegistrationForm() {
    this.stopOtpCooldown();
  
    this.otpStep = false;
    this.registrationOtpCode = '';
    this.pendingSignupData = null;
    this.otpPhoneNumber = '';
    this.otpCooldown = 0;
  
    this.mobileNumber = '';
  }

  // =========================
  // OTP cooldown
  // =========================
  private startOtpCooldown(seconds: number) {
    this.stopOtpCooldown();

    this.otpCooldown = Math.max(0, Math.ceil(seconds));

    this.otpTimer = setInterval(() => {
      if (this.otpCooldown <= 1) {
        this.otpCooldown = 0;
        this.stopOtpCooldown();
        return;
      }

      this.otpCooldown--;
    }, 1000);
  }

  private stopOtpCooldown() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    }
  }

  // =========================
  // Validation
  // =========================
  async checkFormValidation(_formData: ISignUp) {
    var valid = true;
    let email = _formData.email.split('@');

    if (this.mobileNumber == '' || this.mobileNumber == undefined) {
      this.activeError2 = true;
    } else {
      this.activeError2 = false;
    }

    if (this.saveWayKnowType == null) {
      this.activeError1 = true;
    } else {
      this.activeError1 = false;
    }

    if (
      this.saveWayKnowType == null ||
      this.mobileNumber == '' ||
      this.mobileNumber == undefined
    ) {
      valid = false;
      return valid;
    } else {
      console.log('senddata');
    }

    if (this.form.valid) {
      valid = await this.checkEmail(email);
    } else {
      this.checkEmail(email);

      this.formControls.forEach((it, i) => {
        if (this._formcontrol[it.name].status == 'INVALID') {
          this.showError(i);
        }
      });

      valid = false;
    }

    this.deleteError();

    return valid;
  }

  // =========================
  // Password
  // =========================
  showPassClick(item: InputIcon, index: number) {
    this.state = this.state === 'default' ? 'rotated' : 'default';

    setTimeout(() => {
      if (item.placement == 'left-icon') {
        this.formControls[index].type =
          this.formControls[index].type === 'password' ? 'text' : 'password';

        let x = item.src!;
        item.src = this.iconSrc;
        this.iconSrc = x;

        this.state = this.state === 'default' ? 'rotated' : 'default';
      }
    }, 200);
  }

  async checkEmail(email: string[]) {
    var index = this.formControls.findIndex((it) => it.name == 'email');

    if (email?.length == 2) {
      if (email[1].endsWith('.com')) {
        return true;
      } else {
        this.showError(index);
        return false;
      }
    } else {
      this.showError(index);
      return false;
    }
  }

  async showError(index: number) {
    this.formControls[index].hasErr = true;
  }

  deleteError() {
    setTimeout(() => {
      this.formControls.forEach((it) => (it.hasErr = false));
    }, 1000);
  }

  // =========================
  // Route
  // =========================
  getRoute() {
    const fullUrl = window.location.href;
    const urlObj = new URL(fullUrl);
    this.pathAfterCom = urlObj.pathname;
  }

  // =========================
  // Know Type
  // =========================
  get knowType() {
    return this.saveWayKnowType;
  }

  // =========================
  // Destroy
  // =========================
  ngOnDestroy() {
    this.stopOtpCooldown();
  }
}
